module.exports = __webpack_public_path__ + "static/media/hi.c6bdf4a4.png";